import { HttpService } from "../../utils/DesigningHttpService.js";
import { executePlatformOperation, platformPreferenceRequest } from "../platform-admin/platformAdminApi.ts";

export type NotificationRecord = {
  id: number; sendId?: string; languageCode: string; type: number;
  title: string; message: string; sentAt: string; readAt: string | null;
  recipientName?: string; agencyTitle?: string; companyTitle?: string;
};
export type NotificationPage = { records: NotificationRecord[]; total: number };
export type NotificationDraft = { sendId: string; languageCode: string; type: number; title: string; message: string };
export const notificationTypes = [
  { value: 1, label: "بروزرسانی" },
  { value: 2, label: "اطلاعیه" },
  { value: 3, label: "پشتیبانی" },
];
const http = new HttpService();

export function notificationTypeLabel(type: number): string {
  return notificationTypes.find(function (option) { return option.value === type; })?.label || "اعلان";
}

export async function notificationHistory(page: number, all: boolean, search: string, signal: AbortSignal): Promise<NotificationPage> {
  return await platformPreferenceRequest("get", `/platform/notifications?page=${page}&all=${all}&search=${encodeURIComponent(search)}`, undefined, "", signal) as NotificationPage;
}

export async function notificationDetail(id: number, signal: AbortSignal): Promise<NotificationRecord> {
  return await platformPreferenceRequest("get", `/platform/notifications/${id}`, undefined, "", signal) as NotificationRecord;
}

export async function notificationRecipients(language: string, signal: AbortSignal): Promise<{ users: number; agencies: number }> {
  return await platformPreferenceRequest("get", `/platform/notifications/recipients?languageCode=${language}`, undefined, "", signal) as { users: number; agencies: number };
}

export async function sendNotification(draft: NotificationDraft, csrfToken: string): Promise<void> {
  await executePlatformOperation("/platform/notifications", draft, csrfToken);
}

export function readNotifications(signal: AbortSignal): Promise<NotificationRecord[]> {
  return http.getResource("/catalog/notifications", signal);
}

export function markNotificationsRead(id?: number): Promise<unknown> {
  return http.postForData("/catalog/notifications/read", { id });
}
